module.exports = __webpack_public_path__ + "img/insights.f687c15b.svg";